export const validateCompanyName = async (company) => {
  if (!company?.name?.trim().length) {
    return { isValid: false, error: "Company name is required." };
  }

  if (company?.name.trim().length > 100) {
    return { isValid: false, error: "Company name must be shorter than 100 characters." };
  }

  if (company?.is_trashed) {
    return { isValid: false, error: "Company trashed. Go to Trash to restore company." };
  }

  if (company?.is_archived) {
    return { isValid: false, error: "Company archived. Go to Archive to restore company." };
  }

  return { isValid: true };
};
